import React from "react";
import Image from "@herb/components/Image";
import "./index.css";

const DispensaryDealCard = ({ deal, cardNum }) => {
  const { dealsPageUrl } = deal.contentDeals.content[0];
  const { contentMobileImage, featuredImage } = deal;

  return (
    <div className="dispensaryDealCard">
      <a
        className="dispensaryDealCardImageLink desktop"
        href={dealsPageUrl}
        target="_blank"
        rel="noreferrer"
      >
        <Image
          className="dispensaryDealCardImage"
          src={featuredImage?.node?.sourceUrl}
        />
      </a>
      <a
        className="dispensaryDealCardImageLink mobile"
        href={dealsPageUrl}
        target="_blank"
        rel="noreferrer"
      >
        <>
          <Image
            className="dispensaryDealCardImage"
            src={contentMobileImage?.mobileImage?.sourceUrl}
          />
        </>
      </a>
    </div>
  );
};

export default DispensaryDealCard;
